<ion-content class="highlight-gradient">
  <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <div class="container container_login">
    <main class="login">
      <ion-grid [fixed]="true">
        <ion-row>
          <ion-col>
            <div class="login__slider" *ngIf="contentLoaded">
              <splide [options]="{type: 'fade', perPage: 1, autoplay: true, arrows: false, rewind: true, rewindSpeed: 0, interval: 7000}" class="slider slider_login">
                <splide-slide>
                  <div class="slider__content">
                    <img src="../../../assets/img/logo.svg" alt="" draggable="false">
                    <h2 class="slider__title">Добро пожаловать<br> в мир аренды<br> Dress Change!</h2>
                    <div class="slider__text">
                      Здесь Вы сможете взять одежду<br> и аксессуары на время или сдать<br> в аренду то, что висит<br> в вашем шкафу.
                    </div>
                  </div>
                </splide-slide>

                <splide-slide>
                  <div class="slider__content">
                    <h2 class="slider__title">Немного о наших правилах:</h2>
                    <div class="slider__text">
                      Мы рекомендуем Вам размещать на платформе исключительно качественные вещи в хорошем состоянии.<br>
                      Убедительно просим Вас бережно относиться к вещам, которые Вы берёте в аренду.
                      <small>Подробнее с нашими правилами Вы можете ознакомиться в личном кабинете</small>
                    </div>
                  </div>
                </splide-slide>

                <splide-slide>
                  <div class="slider__content">
                    <div class="slider__text">
                      Используйте безопасную сделку для бронирования, внесения залога и оплаты аренды.<br> Залоговые
                      средства вернуться к Вам сразу после того, как Вы вернёте вещь обратно.
                    </div>
                  </div>
                </splide-slide>
              </splide>
            </div>
          </ion-col>
        </ion-row>

        <ion-row>
          <ion-col>
            <ion-card class="card mt-2 mb-2">
              <ion-card-content>
                <div class="card__buttons mt-2 mb-2">
                  <ion-button shape="round" color="danger" class="button button_round" (click)="login()">Войти</ion-button>
                  <ion-button shape="round" class="button button_round button_light mt-2" (click)="registration()">Регистрация</ion-button>
                </div>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </main>
  </div>
</ion-content>
